import { Injectable } from '@angular/core';

declare var swal: any;

@Injectable()
export class SweetAlertService {

    constructor() { }

    public info(title: string, text: string, callback?: any) {
        swal({
            showConfirmButton: false,
            title: title,
            // text: text,
            timer: 2000,
            type: 'info',
            html: text
        }).then(() => {
            if (!!callback) {
                callback();
            }
        });
    }

    public success(title: string, text: string, callback?: any) {
        swal({
            showConfirmButton: false,
            title: title,
            // text: text,
            timer: 2000,
            type: 'success',
            html: text
        }).then(() => {
            if (!!callback) {
                callback();
            }
        });
    }

    public error(title: string, text: string, callback?: any) {
        swal({
            showConfirmButton: false,
            title: title,
            // text: text,
            timer: 5000,
            type: 'error',
            html: text
        }).then(() => {
            if (!!callback) {
                callback();
            }
        });
    }
    
    public errorWait(title: string, text: string, callback?: any) {
        swal({
            showConfirmButton: true,  
            confirmButtonText: 'Aceptar',
            title: title,
            type: 'error', 
            html: text,  
            allowOutsideClick: false, 
            allowEscapeKey: false, 
            showCancelButton: false,
            width: '600px'
        }).then(() => {
            if (callback) {
                callback();
            }
        });
    }

    public warning(title: string, text: string, callback: any) {
        swal({
            showConfirmButton: false,
            title: title,
            // text: text,
            timer: 2000,
            type: 'warning',
            html: text
        }).then(() => {
            if (!!callback) {
                callback();
            }
        });
    }

    public question(title: string, text: string, confirmButtonText: string, cancelButtonText: string, confirmCallback: any, cancelCallback?: any) {
        swal({
            title: title,
            // text: text,
            html: text,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#039BE5',
            cancelButtonColor: '#F44336',
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            buttonsStyling: true
        }).then((result) => {
            console.log('SweetAlertService > question > result', result);
            if (result.value) {
                if (!!confirmCallback) {
                    confirmCallback();
                }
            } else {
                if (!!cancelCallback) {
                    cancelCallback();
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/sweet-alert/sweet-alert.service.ts